import { render } from "./VideoFeed.vue?vue&type=template&id=4bd8d4b8"
import script from "./VideoFeed.vue?vue&type=script&lang=js"
export * from "./VideoFeed.vue?vue&type=script&lang=js"

import "./VideoFeed.vue?vue&type=style&index=0&id=4bd8d4b8&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__